import { generateCollectionIdAndName } from '@wix/wix-data-client-common'

import type { PresetDefinition } from '../../presets/types'
import type { CollectionsApi } from '@wix/wix-code-collections-api'

type Params = {
  preset: PresetDefinition
  collectionsApi: CollectionsApi
}

export const getPresetDataForNewCollection = async ({
  preset,
  collectionsApi,
}: Params) => {
  const { schema, records } = preset.collections[0]
  const allCollections = await collectionsApi.getAll()
  const { collectionId, collectionName } = generateCollectionIdAndName({
    allCollections,
    baseName: schema.displayName,
  })

  return { collectionId, collectionName, schema, records }
}
